export const version = "wallet/5.6.2";
//# sourceMappingURL=_version.js.map